import { useSelector } from 'react-redux';
import { RootState } from 'store';

const WelcomeHero = () => {
  const isDarkMode = useSelector((state: RootState) => state.theme.isDarkMode);

  return (
    <div className="text-text-primary space-y-6">
      <div className="">
        <img
          src={isDarkMode ? '/gif-maker-dark.png' : '/gif-maker.png'}
          alt="GIF Maker Welcome Image"
          className="max-h-[120px] md:max-h-[146px] h-full"
        />
      </div>
      <h1 className="text-2xl md:text-5xl font-medium text-text-primary lg:leading-[60px] md:max-w-[400px] mb-2">
        Welcome to <br className="hidden md:block" /> GIF Maker
      </h1>
      <p className="text-sm lg:text-xl font-normal text-text-primary md:w-[400px] mb-6 lg:mb-0">
        Create eye-catching and shareable GIFs effortlessly with our intuitive
        tool. Transform your ideas into captivating animated visuals that grab
        attention and elevate your content in no time.
      </p>
    </div>
  );
};

export default WelcomeHero;
